import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const swiper = new Swiper('.gameplay-gallery-swiper', {
  direction: 'horizontal',
  loop: true,
  watchOverflow: true,
  centeredSlides: false,
  slideToClickedSlide: true,
  initialSlide: 2,
  grabCursor: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
    pageUpDown: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.001,
      spaceBetween: 16,
    },
    1200: {
      slidesPerView: 3.2,
      spaceBetween: 48,
      centeredSlides: true,
    },
  },
  modules: [Pagination],
  pagination: {
    el: '.gameplay-gallery-pagination',
    clickable: true,
  },
});
